// extracted by mini-css-extract-plugin
export default {"pageNotFound":"PageNotFound_pageNotFound__DB43W","pageNotFoundHeading":"PageNotFound_pageNotFoundHeading__WKL8Y"};